import { gql } from '@soundxyz/gql-string';
import { TopTrendingPostsDocument, useQuery } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  query TopTrendingPosts {
    topTrendingPosts {
      id
      createdAt
      webappUri
      __typename
      creator {
        id
        ...UserActivityDetail
      }
      ...TopPostInfo
      ...TopReleasePost
      ...TopPlaylistPost
      ...TopArtistDropPost
      ...FeedPostActionsInfo
      ...PostGroupItem
      ...TopPostRepost
    }
  }

  fragment TopPostRepost on Repost {
    creator {
      id
      username
      webappUri
    }
    originalPost {
      __typename
      id
      webappUri

      createdAt
      commentCount

      creator {
        id
        ...UserActivityDetail
      }

      ...PostGroupItem
    }
  }

  fragment TopPostInfo on Post {
    id
    content
    lexicalContent
    commentCount
    upvoteCount
    webappUri
    createdAt
    creator {
      id
      ...UserActivityDetail
    }
  }

  fragment TopPlaylistPost on PlaylistPost {
    optionalShelf {
      id
      name
    }
  }

  fragment TopReleasePost on ReleasePost {
    optionalRelease {
      id
      title
      artist {
        id
        name
      }
      track {
        id
      }
      listeningParty
    }
  }

  fragment TopArtistDropPost on ArtistDropPost {
    release {
      id
      title
      artist {
        id
        name
      }
      track {
        id
      }
      listeningParty
      ...ArtistDropRelease
    }
  }
`);

export const useTopPosts = (topPostLimit = 4) => {
  const { data, isLoading } = useQuery(TopTrendingPostsDocument, {
    staleTime: 0,
    filterQueryKey: { topPostLimit },
  });
  const topPosts = data?.data.topTrendingPosts ?? [];
  const firstLimitPosts = topPosts.slice(0, topPostLimit);
  const restOfThePosts = topPosts.slice(topPostLimit);

  return { topPosts: firstLimitPosts, discoverMorePosts: restOfThePosts, isLoading };
};
